<template>
  <div class="p-fluid p-formgrid p-grid">
    <div v-for="f in fields" :key="f.fieldKey" :class="['p-field', f.type === 'textarea' ? 'p-col-12' : colClass]">
      <label :for="'pseJob_' + f.fieldKey">{{ f.label }} <span v-if="f.mandatory" class="pse-req">*</span></label>
      <Calendar v-if="f.type === 'date'" :id="'pseJob_' + f.fieldKey" :value="dateOf(f.fieldKey)" dateFormat="dd/mm/yy" :showIcon="true"
        :disabled="disabled" @input="set(f.fieldKey, toDmy($event))" :class="{ 'p-invalid': invalid(f) }" />
      <SelectButton v-else-if="f.type === 'yesno'" :id="'pseJob_' + f.fieldKey" :value="value[f.fieldKey]" :options="yesNoOptions"
        optionLabel="label" optionValue="value" :disabled="disabled" @input="setYesNo(f.fieldKey, $event)" :class="{ 'p-invalid': invalid(f) }" />
      <InputNumber v-else-if="f.type === 'number'" :id="'pseJob_' + f.fieldKey" :value="value[f.fieldKey]" :useGrouping="false"
        :disabled="disabled" @input="set(f.fieldKey, $event)" :class="{ 'p-invalid': invalid(f) }" />
      <Textarea v-else-if="f.type === 'textarea'" :id="'pseJob_' + f.fieldKey" :value="value[f.fieldKey]" rows="3" :autoResize="true"
        :disabled="disabled" @input="set(f.fieldKey, $event)" :class="{ 'p-invalid': invalid(f) }" />
      <InputText v-else :id="'pseJob_' + f.fieldKey" :value="value[f.fieldKey]" :disabled="disabled"
        @input="set(f.fieldKey, $event)" :class="{ 'p-invalid': invalid(f) }" />
    </div>
  </div>
</template>

<script>
import { JOB_FIELD_TYPES, BID_KEYS, isBlank, toDmy, fromDmy, fieldLabel } from './sharedEnquiryLogic'

const PROJECT_KEYS = ['project', 'postcodeArea']

export default {
  name: 'JobFields',
  props: {
    value: { type: Object, required: true },
    settings: { type: Array, default: () => [] },
    submitted: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // design B's 800px dialog keeps today's two columns
    colClass: { type: String, default: 'p-col-12 p-md-6 p-lg-4' },
    // design C's start dialog asks only for what the job cannot be saved without
    onlyMandatory: { type: Boolean, default: false }
  },
  data() {
    return { yesNoOptions: [{ label: 'Yes', value: true }, { label: 'No', value: false }] }
  },
  computed: {
    // The job-level settings in the Excel order; keys the settings do not list still show (optional).
    fields() {
      const byKey = {}
      this.settings
        .filter(s => s.level !== 'bid' && !PROJECT_KEYS.includes(s.fieldKey) && !BID_KEYS.includes(s.fieldKey))
        .forEach(s => { byKey[s.fieldKey] = s })
      const known = Object.keys(JOB_FIELD_TYPES).map(k => byKey[k] || { fieldKey: k, mandatory: false })
      const extra = Object.keys(byKey).filter(k => !JOB_FIELD_TYPES[k]).map(k => byKey[k])
      return known.concat(extra).filter(s => !this.onlyMandatory || s.mandatory)
        .map(s => ({ ...s, label: fieldLabel(s), type: JOB_FIELD_TYPES[s.fieldKey] || 'text' }))
    }
  },
  methods: {
    toDmy,
    dateOf(key) { return fromDmy(this.value[key]) },
    invalid(f) { return this.submitted && f.mandatory && isBlank(this.value[f.fieldKey]) },
    set(key, v) { this.$emit('input', { ...this.value, [key]: v }) },
    // PrimeVue 2's SelectButton un-selects (emits null) when the chosen option is clicked again: keep the answer
    setYesNo(key, v) { if (v !== null && v !== undefined) this.set(key, v) }
  }
}
</script>

<style scoped>
@import './sharedEnquiry.css';
</style>
